
const experience = [
  {
    id: 0,
    role: "Founder",
    company:"Design and Code",
    link:"https://designandcode.us/",
    period:"Jan 2021 - Present · 18 mos",
    content: [
      "I founded Design and Code in Jan 2021 and now we have more than 4k+ community members from globally. Our community welcomes designers and developers: beginners, intermediates, and experts willing to learn together.",
      "We encourage sharing resources and learning experiences, organizing events, and providing feedback for our members to grow as they learn.",
      "We wish to provide a platform for designers and developers to connect, collaborate and comprehend together."
    ],
  },
  {
    id: 1,
    role: "Mentor",
    company:"Google DSC.",
    link:"https://gdsc.community.dev/padre-conceicao-college-of-engineering-goa/",
    period:"Sep 2021 - Present · 1 mos",
    content: [
      "Teaching students the whole process of developing websites which include designing, developing, and open-sourcing the project using Git and GitHub.",
      "Lead the project and mentored several students under an Open Source Program.",
    ],
  },
  {
    id: 2,
    role: "UI/UX Designer",
    company:"Imagine Works",
    link:"https://imagine-works.com/",
    period:"June 2021 - Sep 2021 · 3 mos",
    content: [
      "Designed entire User Interface for various websites and apps from scratch depending on the problem statement provided to me.",
      "Designed 10+ projects and worked closely with developers, also handed the designs to the software development team.",
      "Lead the design team, gave daily reports, conducted meetings, managed the projects and maintained proper documentation."
    ],
  },
  {
    id: 3,
    role: "Web Developer",
    company:"GirlScript Goa",
    link:"https://www.linkedin.com/company/girlscriptgoa/mycompany/",
    period:"Aug 2020 - Present · 12 mos",
    content: [
      "Designed the UI and developed the official website of GirlScript Goa.",
      "I learned how to work cooperatively in a team and completed the development and design work before the deadline.",
      "As a part of the core team, I have helped the community in organizing various events. Also worked as Graphic Designer to design the official posters."
    ],
  },
  {
    id: 4,
    role: "Web Developer | Graphic Designer",
    company:"GSSOC",
    link:"https://gssoc.girlscript.tech/",
    period:"Jan 2021 - June 2021 · 6 mos",
    content: [
      "Designed the official website UI and the posters for social media.",
      "As a part of the organizing core team, i have helped the team in various aspects including handling more than 8K participants, designing the server, organizing events etc.",
      "I designed certificates, event ticket, registration poster, event schedule poster, poster for speakers of the event, event winners poster, etc."
    ],
  },
  {
    id: 5,
    role: "Student Intern",
    company:"Persistent Systems",
    link:"https://www.persistent.com/",
    period:"Sep 2020 - Oct 2020 · 1 mos",
    content: [
      "Worked on Pneumonia classification using Chest X-ray images in a team.",
      "Completed the task of building privacy-preserving machine learning models using Federated Learning.",
    ],
  },
  {
    id: 5,
    role: "Graphic Designer",
    company:"GirlScript Foundation",
    link:"https://www.girlscript.tech/home",
    period:"Jan 2021 - June 2021 · 6 mos",
    content: [
      "Worked as Graphic Designer for Education Outreach Scholarship Program.",
      "I designed certificates, event ticket, registration poster, event schedule poster, poster for speakers of the event, event winners poster, etc.",
    ],
  },
  {
    id: 6,
    role: "Campus Ambassador",
    company:"YAY - Celebrating Education",
    link:"https://www.gsyay.com/",
    period:"Sep 2020 - Oct 2020 · 1 mos",
    content: [
      "Worked as Campus Ambassador at YAY.",
      "Promoted the platform on socials, helped bringing in more registrations to the platform, making graphics to promote, helped in growing followers, and reaching out bigger audience.",
    ],
  },
  
];



export default experience;